"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.keys");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuexClass = require("vuex-class");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

var _request = require("@/services/request/request.service");

var _milkRunV = require("@/mixins/milk-run-v2/milk-run-v2");

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

var _ganttChart = require("./gantt-chart.scss");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MRGanttChartComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MRGanttChartComponent, _Mixins);

  var _super = _createSuper(MRGanttChartComponent);

  function MRGanttChartComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MRGanttChartComponent);
    _this = _super.apply(this, arguments);
    _this.request = null;
    _this.truckWidth = 0;
    _this.ganttChartCellWidth = 30;
    _this.leftWidth = 225;
    _this.smallLeftWidth = 225;
    _this.locations = {};
    _this.timeList = [];
    _this.numOfDaysAdded = 0;
    _this.autoAddedDays = 0;
    _this.timeStepper = 240;
    _this.autoScrollInterval = null;
    _this.scrollTimeRefresh = 1; // seconds

    _this.currentTimeInterval = null;
    _this.currentTimeRefresh = 60; // seconds

    _this.currentTimeLeft = null;
    _this.currentSeconds = null;
    _this.timerOnInit = false;
    _this.bufferTrucks = [];
    _this.audioPath = require('@/assets/audio/mixkit-bell-notification-933.wav');
    _this.audio = new Audio(_this.audioPath);
    _this.isSortAsc = {
      driverName: null,
      plateNumber: null,
      projectCode: null
    };
    return _this;
  }

  (0, _createClass2.default)(MRGanttChartComponent, [{
    key: "onInitAutoAddedDaysChanges",
    value: function onInitAutoAddedDaysChanges(newVal) {
      this.timeList = this.getTimeList(newVal);
    }
  }, {
    key: "onPlanDateRangeChanges",
    value: function onPlanDateRangeChanges(newVal) {
      if (this.planViewType === 'daily') {
        this.timeList = this.getTimeList(0, newVal[0], newVal[1]);
      }
    }
  }, {
    key: "onTruckLoadingChanges",
    value: function onTruckLoadingChanges() {
      var _this2 = this;

      this.$nextTick(function () {
        var el = _this2.helper.get(_this2.$refs, 'ganttChart', null);

        if (!el) {
          return false;
        }

        el.scrollTo(_this2.xCoordinate, el.scrollTop);

        _this2.getCurrentTimeLocation();
      });
    }
    /*@Watch('truckStatusFromSocket')
    onTruckStatusFromSocketChanges(newVal) {
    }*/

  }, {
    key: "filteredTrucks",
    get: function get() {
      var _this3 = this;

      this.bufferTrucks = [];

      if (this.$plan.trucks.length === 0) {
        return [];
      }

      this.$plan.trucks.forEach(function (truck) {
        var findTruck = _this3.helper.find(_this3.bufferTrucks, function (t) {
          return t['vehicleId'] === (truck['vehicleId'] && t['driverId'] === truck['driver']['id']);
        });

        if (!findTruck || findTruck === undefined) {
          var _this3$getTruckStatus = _this3.getTruckStatus(truck, truck.routes),
              className = _this3$getTruckStatus.className;

          _this3.bufferTrucks.push(_objectSpread(_objectSpread({}, truck), {}, {
            driverId: truck['driver']['id'],
            status: className || 'NORMAL',
            message: ''
          }));
        }
      });

      if (this.alertType.length === 0) {
        return this.$plan.trucks || [];
      }

      return this.bufferTrucks.filter(function (truck) {
        var statuses = _this3.isTruckLate(truck, truck.routes);

        var status = _this3.helper.get(Object.keys(statuses), '0', 'NORMAL').toLowerCase();

        return _this3.helper.includes(_this3.alertType, status);
      });
    }
  }, {
    key: "gcContainerStyle",
    get: function get() {
      return {
        height: this.ganttChartHeight + 'px',
        top: 0
      };
    }
  }, {
    key: "gcHeaderStyle",
    get: function get() {
      return {
        width: this.truckWidth + 'px'
      };
    }
  }, {
    key: "isTodayInRange",
    get: function get() {
      return (0, _moment.default)(new Date()).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]');
    }
  }, {
    key: "xCoordinate",
    get: function get() {
      var el = this.helper.get(this.$refs, 'ganttChart', null);

      if (!el) {
        return 0;
      }

      var start = (0, _moment.default)(this.$planDateRange[0]).format('YYYY-MM-DD 00:00');
      var end = (0, _moment.default)(new Date());

      if (!this.isTodayInRange) {
        end = (0, _moment.default)(this.$planDateRange[1]);
      }

      var duration = _moment.default.duration(end.diff(start, 'minutes'), 'minutes').asMinutes();

      var xAxis = duration * this.ganttChartCellWidth / this.timeStepper;
      return xAxis - el.clientWidth / 3;
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      clearTimeout(this.timer);

      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
      }

      if (this.currentTimeInterval) {
        clearInterval(this.currentTimeInterval);
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.ganttChartCellWidth = Number(_ganttChart.ganttChartCellWidth.slice(0, -2));
      this.leftWidth = Number(_ganttChart.leftWidth.slice(0, -2));
      this.timeStepper = this.defaultTimeStepper;
      this.timeList = this.getTimeList();
      this.request = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this4 = this;

      this.startTimer(60 - new Date().getSeconds()); // prevent notification burst

      setTimeout(function () {
        _this4.timerOnInit = true;
      }, 2000);
      this.autoAddedDays = this.initAutoAddedDays;
      this.currentTimeInterval = setInterval(function () {
        _this4.handleHorizontallyScrolling();

        _this4.getCurrentTimeLocation();
      }, this.currentTimeRefresh * 1000);

      if (this.isVerticallyAutoScrolling) {
        this.autoScrollInterval = setInterval(function () {
          _this4.handleVerticallyAutoScrolling();
        }, this.scrollTimeRefresh * 1000);
      }
    }
  }, {
    key: "handleHorizontallyScrolling",
    value: function handleHorizontallyScrolling() {
      if (this.isPause) {
        return false;
      }

      var el = this.helper.get(this.$refs, 'ganttChart', null);

      if (!el) {
        return false;
      }

      el.scrollTo(el.scrollLeft + 4, el.scrollTop);
    }
  }, {
    key: "handleVerticallyAutoScrolling",
    value: function handleVerticallyAutoScrolling() {
      if (this.isPause) {
        return false;
      }

      var el = this.helper.get(this.$refs, 'ganttChart', null);

      if (!el) {
        return false;
      }

      if (el.scrollHeight - el.scrollTop === el.clientHeight && el.scrollHeight !== el.clientHeight) {
        el.scrollTo(el.scrollLeft, 0);
      } else {
        el.scrollBy(0, 2);
      }
    }
  }, {
    key: "openMap",
    value: function openMap(truck) {
      var truckId = truck.vehicleId;
      var truckName = truck.plateNumber;
      var truckData = truck.routes;

      if (truckData.length >= 1) {
        if (truckData[0] && truckData[0]['lat'] && truckData[0]['lng']) {
          this.locations = {
            latitude: Number(truckData[0]['lat']),
            longitude: Number(truckData[0]['lng'])
          };
        }

        if (truckData[0] && truckData[0]['latitude'] && truckData[0]['longitude']) {
          this.locations = {
            latitude: Number(truckData[0]['latitude']),
            longitude: Number(truckData[0]['longitude'])
          };
        }

        this.selectedTruckName = truckName;
        this.selectedTruckData = truckData;
        window.localStorage.setItem('tName', this.helper.toString(this.selectedTruckName));
        window.localStorage.removeItem('tContainerNum');
        window.localStorage.removeItem('tGpsId');
        window.localStorage.setItem('tLocation', this.helper.toString(this.locations));
        window.localStorage.setItem('tData', this.helper.toString(this.selectedTruckData));
        window.localStorage.setItem('tInitEvent', 'polylines');
        var routeData = this.$router.resolve({
          name: 'map'
        });
        window.open(routeData.href, this.selectedTruckName, 'toolbar=no, location=no, status=no, menubar=no, scrollbars=no, resizable=yes, width=600, height=600');
      }
    }
  }, {
    key: "clearSelectedTrucks",
    value: function clearSelectedTrucks() {
      this.selectedTruckName = '';
      this.selectedTruckData = [];
    }
  }, {
    key: "getTimeList",
    value: function getTimeList() {
      var daysOfIncrement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$planDateRange[0];
      var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.$planDateRange[1];
      var stepper = this.timeStepper;
      var start = this.helper.isUndefined(startDate) ? (0, _moment.default)(this.$planDateRange[0]) : (0, _moment.default)(startDate);
      var eDate = this.helper.isUndefined(startDate) ? (0, _moment.default)(this.$planDateRange[1]) : (0, _moment.default)(endDate);
      var end = daysOfIncrement === 0 ? (0, _moment.default)(eDate) : (0, _moment.default)(startDate).add(daysOfIncrement, 'days');

      var duration = _moment.default.duration(end.diff(start, 'days'), 'days').asDays();

      var endTime = (0, _moment.default)('00:00', 'HH:mm').subtract(stepper, 'm').format('HH:mm');
      var arr = [];

      for (var i = 0; i <= duration; i++) {
        var time = (0, _moment.default)('00:00', 'HH:mm');
        var obj = {
          date: i === 0 ? start.format('YYYY-MM-DD') : start.add(1, 'days').format('YYYY-MM-DD'),
          hourList: [],
          minuteList: [0]
        };
        var interval = 60;
        var period = 'm';

        var periodsInADay = _moment.default.duration(1, 'day').as(period);

        var startTimeMoment = (0, _moment.default)('00:00', 'hh:mm');

        for (var x = 0; x < periodsInADay; x += interval) {
          startTimeMoment.add(x === 0 ? 0 : interval, period);
          obj['hourList'].push(startTimeMoment.format('HH:mm'));
        }

        while (time.format('HH:mm') !== endTime) {
          time = time.add(stepper, 'm');
          obj['minuteList'].push(Number(time.format('mm') === '00' ? '0' : time.format('mm')));
        }

        arr.push(obj);
      }

      var numOfDays = arr.length;

      if (arr[0] && arr[0]['minuteList']) {
        this.truckWidth = numOfDays * arr[0]['minuteList'].length * this.ganttChartCellWidth + (this.$isMobile ? this.smallLeftWidth : this.leftWidth);
      }

      return arr;
    }
  }, {
    key: "getRouteStyles",
    value: function getRouteStyles(_ref) {
      var route = _ref.route,
          dimensionType = _ref.dimensionType,
          routeType = _ref.routeType;

      switch (dimensionType) {
        case 'travellingTime':
          return {
            top: '18px',
            left: this.getLeftDimension(dimensionType, route) + 'px',
            width: this.getWidthDimension(dimensionType, route) + 'px'
          };

        case 'handlingTime':
          return {
            top: '5px',
            height: '30px',
            left: this.getLeftDimension(dimensionType, route) + 'px',
            width: this.getWidthDimension(dimensionType, route) + 'px'
          };

        case 'actualTravellingTime':
          return {
            bottom: '-18px',
            left: this.getLeftDimension(dimensionType, route) + 'px',
            width: this.getWidthDimension(dimensionType, route) + 'px',
            background: '#2C3C8B',
            color: 'white'
          };

        case 'actualHandlingTime':
          return {
            height: '30px',
            left: this.getLeftDimension(dimensionType, route) + 'px',
            width: this.getWidthDimension(dimensionType, route) + 'px',
            background: route.status === 'COMPLETED' ? '#2C3C8B' : 'white',
            color: route.status === 'COMPLETED' ? 'white' : 'black',
            border: route.status === 'COMPLETED' ? 'none' : '1px solid #2C3C8B'
          };
      }
    }
  }, {
    key: "getContainerStyles",
    value: function getContainerStyles(route, routeType) {
      switch (routeType) {
        case 'plannedRoutes':
          return {
            left: this.getContainerDimension(true, route, routeType) + 'px',
            width: this.getContainerDimension(false, route, routeType) + 'px',
            height: '40px'
          };

        case 'actualRoutes':
          return {
            bottom: '0',
            left: this.getContainerDimension(true, route, routeType) + 'px',
            width: this.getContainerDimension(false, route, routeType) + 'px',
            height: '40px'
          };
      }
    }
  }, {
    key: "getContainerDimension",
    value: function getContainerDimension(isLeft) {
      var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var routeType = arguments.length > 2 ? arguments[2] : undefined;
      var newRoute = this.helper.cloneDeep(route);
      var start = this.helper.convertTimezone(newRoute.startTime, this.$timezone);
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      newRoute.runningTime = Number(newRoute.runningTime) / 60;
      newRoute.handlingTime = Number(newRoute.handlingTime) / 60;
      newRoute.actualData.runningTime = route['status'] === 'COMPLETED' ? Number(newRoute.actualData.runningTime) / 60 : Number(newRoute.actualData.runningTime) !== 0 ? Number(newRoute.actualData.runningTime) / 60 : newRoute.runningTime;
      newRoute.actualData.handlingTime = route['status'] === 'COMPLETED' ? Number(newRoute.actualData.handlingTime) / 60 : Number(newRoute.actualData.handlingTime) !== 0 ? Number(newRoute.actualData.handlingTime) / 60 : newRoute.handlingTime;

      if (routeType === 'actualRoutes') {
        if (newRoute.waypointType !== 'T') {
          start = this.helper.convertTimezone(newRoute.actualData.startTime, this.$timezone);
        }
      }

      if (this.helper.isUndefined(start)) {
        return 0;
      }

      var date = (0, _moment.default)(start).format('YYYY-MM-DD');
      var startTime = (0, _moment.default)(start).format('YYYY-MM-DD 00:00');
      var endTime = (0, _moment.default)(start);

      var duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();

      if (date !== this.$planDateRange[0]) {
        var diff = (0, _moment.default)(date).diff((0, _moment.default)(this.$planDateRange[0]), 'days');
        startTime = (0, _moment.default)(start).subtract(diff, 'days').format('YYYY-MM-DD 00:00');
        duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();
      }

      if (routeType === 'plannedRoutes') {
        return multiplier * (isLeft ? duration : newRoute.runningTime + newRoute.waitingTime + newRoute.handlingTime);
      }

      if (routeType === 'actualRoutes') {
        return multiplier * (isLeft ? duration : newRoute.actualData.runningTime + newRoute.actualData.waitingTime + newRoute.actualData.handlingTime);
      }
    }
    /**
     * 30 minutes   = 54      <-- ganttChartCellWidth
     * 1 minute     = 1.8px   <-- 54/this.stepper
     * */

  }, {
    key: "getLeftDimension",
    value: function getLeftDimension(timeType, route) {
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      var newRoute = this.helper.cloneDeep(route);
      newRoute.runningTime = Number(newRoute.runningTime) / 60;
      newRoute.handlingTime = Number(newRoute.handlingTime) / 60;
      newRoute.actualData.runningTime = route['status'] === 'COMPLETED' ? Number(newRoute.actualData.runningTime) / 60 : Number(newRoute.actualData.runningTime) !== 0 ? Number(newRoute.actualData.runningTime) / 60 : newRoute.runningTime;
      newRoute.actualData.handlingTime = route['status'] === 'COMPLETED' ? Number(newRoute.actualData.handlingTime) / 60 : Number(newRoute.actualData.handlingTime) !== 0 ? Number(newRoute.actualData.handlingTime) / 60 : newRoute.handlingTime;

      if (timeType === 'travellingTime') {
        return 0;
      }

      if (timeType === 'handlingTime') {
        return multiplier * (newRoute.runningTime + newRoute.waitingTime);
      }

      if (timeType === 'actualTravellingTime') {
        return 0;
      }

      if (timeType === 'actualHandlingTime') {
        return multiplier * (newRoute.actualData.runningTime + newRoute.actualData.waitingTime);
      }
    }
  }, {
    key: "getWidthDimension",
    value: function getWidthDimension(timeType, route) {
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      var newRoute = this.helper.cloneDeep(route);
      newRoute.runningTime = Number(newRoute.runningTime) / 60;
      newRoute.handlingTime = Number(newRoute.handlingTime) / 60;
      newRoute.actualData.runningTime = route['status'] === 'COMPLETED' ? Number(newRoute.actualData.runningTime) / 60 : Number(newRoute.actualData.runningTime) !== 0 ? Number(newRoute.actualData.runningTime) / 60 : newRoute.runningTime;
      newRoute.actualData.handlingTime = route['status'] === 'COMPLETED' ? Number(newRoute.actualData.handlingTime) / 60 : Number(newRoute.actualData.handlingTime) !== 0 ? Number(newRoute.actualData.handlingTime) / 60 : newRoute.handlingTime;

      if (timeType === 'travellingTime') {
        return multiplier * newRoute.runningTime;
      }

      if (timeType === 'handlingTime') {
        // return multiplier * newRoute.handlingTime;
        return newRoute.handlingTime < 1 ? multiplier : multiplier * newRoute.handlingTime;
      }

      if (timeType === 'actualTravellingTime') {
        return multiplier * newRoute.actualData.runningTime;
      }

      if (timeType === 'actualHandlingTime') {
        // return multiplier * newRoute.actualData.handlingTime;
        return newRoute.actualData.handlingTime < 1 ? multiplier : multiplier * newRoute.actualData.handlingTime;
      }
    }
  }, {
    key: "getCurrentTimeLocation",
    value: function getCurrentTimeLocation() {
      if (this.isPause) {
        return false;
      }

      var multiplier = this.ganttChartCellWidth / this.timeStepper; // const start = moment('2021-06-10 08:01:00');

      var start = (0, _moment.default)(new Date());
      var date = (0, _moment.default)(start).format('YYYY-MM-DD');
      var startTime = (0, _moment.default)(start).format('YYYY-MM-DD 00:00');
      var endTime = (0, _moment.default)(start);

      var duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();

      if (date !== this.$planDateRange[0]) {
        var diff = (0, _moment.default)(date).diff((0, _moment.default)(this.$planDateRange[0]), 'days');
        startTime = (0, _moment.default)(start).subtract(diff, 'days').format('YYYY-MM-DD 00:00');
        duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();
      }

      this.currentTimeLeft = multiplier * duration;
    }
  }, {
    key: "getGCRowClass",
    value: function getGCRowClass(truck, truckIndex) {
      var isTruckLate = this.isTruckLate(truck, truck.routes);
      return _objectSpread({
        'bdr-btm-none': truckIndex === this.filteredTrucks.length - 1
      }, isTruckLate);
    }
  }, {
    key: "getGCRowStyle",
    value: function getGCRowStyle(truck, truckIndex) {
      return {
        width: this.truckWidth + 'px',
        'margin-top': truckIndex === 0 ? '1px' : '0'
      };
    }
  }, {
    key: "isDateInRange",
    value: function isDateInRange(route, routeType) {
      switch (routeType) {
        case 'plannedRoutes':
          return (0, _moment.default)(route.startTime).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]') || (0, _moment.default)(route.endTime).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]') || (0, _moment.default)(this.$planDateRange[0]).isBetween(route.startTime, route.endTime, 'days', '[]') || (0, _moment.default)(this.$planDateRange[1]).isBetween(route.startTime, route.endTime, 'days', '[]');

        case 'actualRoutes':
          return (0, _moment.default)(route.actualData.startTime).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]') || (0, _moment.default)(route.actualData.endTime).isBetween(this.$planDateRange[0], this.$planDateRange[1], 'days', '[]') || (0, _moment.default)(this.$planDateRange[0]).isBetween(route.actualData.startTime, route.actualData.endTime, 'days', '[]') || (0, _moment.default)(this.$planDateRange[1]).isBetween(route.actualData.startTime, route.actualData.endTime, 'days', '[]');
      }
    }
  }, {
    key: "getDateLeft",
    value: function getDateLeft(_ref2) {
      var dateIndex = _ref2.dateIndex,
          minuteLength = _ref2.minuteLength;
      return "".concat(this.ganttChartCellWidth * (minuteLength * dateIndex), "px");
    }
  }, {
    key: "getHourLeft",
    value: function getHourLeft(_ref3) {
      var dateIndex = _ref3.dateIndex,
          hourIndex = _ref3.hourIndex,
          hourLength = _ref3.hourLength;
      var counter = hourLength * dateIndex + hourIndex;
      return "".concat(6 * this.ganttChartCellWidth * counter, "px");
    }
  }, {
    key: "getMinuteLeft",
    value: function getMinuteLeft(_ref4) {
      var dateIndex = _ref4.dateIndex,
          minuteIndex = _ref4.minuteIndex,
          minuteLength = _ref4.minuteLength;
      var counter = minuteLength * dateIndex + minuteIndex;
      return "".concat(this.ganttChartCellWidth * counter, "px");
    }
  }, {
    key: "getMinuteStyle",
    value: function getMinuteStyle(minute) {
      if (minute === 0) {
        return {
          'padding-left': '10px'
        };
      } else if (minute > 0 && minute <= 10) {
        return {
          'padding-left': '7px'
        };
      } else {
        return {
          'padding-left': '5px'
        };
      }
    }
  }, {
    key: "isTruckLate",
    value: function isTruckLate(truck, routes) {
      if (!routes || routes.length === 0) {
        return null;
      }

      var truckIndex = this.bufferTrucks.findIndex(function (t) {
        return t['vehicleId'] === truck['vehicleId'] && t['driverId'] === truck['driver']['id'];
      });

      if (truckIndex === -1) {
        return null;
      }

      var _this$getTruckStatus = this.getTruckStatus(truck, routes),
          route = _this$getTruckStatus.route,
          className = _this$getTruckStatus.className,
          isTerminateEarly = _this$getTruckStatus.isTerminateEarly;

      if (isTerminateEarly) {
        return (0, _defineProperty2.default)({}, className, true);
      }

      var driverName = this.helper.get(route, 'driverName', '-');
      var plateNumber = this.helper.get(route, 'plateNumber', '-');
      var projectCode = this.helper.uniq(this.helper.get(route, 'projectCode', [])).join(', ');
      var companyName = this.helper.uniq(this.helper.get(route, 'companyName', [])).join(', ');
      var shipmentReference = this.helper.uniq(this.helper.get(route, 'shipmentReference', [])).join(', ');
      var msgTitle = "".concat(driverName, " ").concat(plateNumber, " ").concat(projectCode, " ").concat(companyName, " ").concat(shipmentReference, " ").concat(this.$t('notification.notYetArrived'));
      var message = {
        title: msgTitle,
        duration: 30000
      }; // this.logger.info('isTruckLate', this.bufferTrucks[truckIndex]['status'], className);

      if (this.bufferTrucks[truckIndex]['status'] !== className) {
        this.bufferTrucks[truckIndex]['status'] = className;
        this.bufferTrucks[truckIndex]['message'] = msgTitle;

        if (this.timerOnInit && route && !this.helper.isEmptyObject(route)) {
          if (className === 'YELLOW') {
            _elementUi.Notification.warning(message);

            this.audio.play();
          } else if (className === 'RED') {
            _elementUi.Notification.error(message);

            this.audio.play();
          } // handled on the backend

          /*if (['YELLOW', 'RED'].includes(className)) {
              this.logger.info('Insert Log', className);
               this.milkRunV2API.postLog({
                  userEmail: this.$userInformation.user.name,
                  type: 'MILKRUN',
                  logType: className,
                  orderId: route['_id'],
                  code: route['code'],
                  data: { ...route },
              });
          }*/
          // handled on the backend

        }
      }

      return (0, _defineProperty2.default)({}, className, true);
    }
  }, {
    key: "getTruckStatus",
    value: function getTruckStatus(truck, routes) {
      if (!routes || routes.length === 0) {
        return {
          route: null,
          className: null,
          isTerminateEarly: false
        };
      }

      var currentTime = (0, _moment.default)(new Date());
      var quiteLateThreshold = Number(this.helper.get(this.$userSetting, 'default22', 60));
      var lateThreshold = Number(this.helper.get(this.$userSetting, 'default23', 60));
      var route = null;
      var className = 'NORMAL';
      var isTerminateEarly = false;
      var firstActive = this.helper.find(routes, function (r) {
        var duration = _moment.default.duration(currentTime.diff(r.estimateTime));

        var seconds = duration.asSeconds();
        return r.status === 'ACTIVE' && Math.abs(seconds) <= 3600;
      });
      var lastInTransit = this.helper.findLast(routes, function (r) {
        var duration = _moment.default.duration(currentTime.diff(r.endTime));

        var seconds = duration.asSeconds();
        return r.status === 'INTRANSIT' && Math.abs(seconds) <= 3600;
      });
      var lastCompleted = this.helper.findLast(routes, function (r) {
        return r.status === 'COMPLETED';
      });
      /*const firstDelay = this.helper.find(routes, (r) => {
          const startLogType = this.helper.get(r, 'additionalData.startLogType', 'NORMAL');
          const endLogType = this.helper.get(r, 'additionalData.endLogType', 'NORMAL');
           return startLogType === 'RED' || endLogType === 'RED';
      });
       // For testing purposes
      if (truck.driver.id === 277 && truck.plateNumber === '51F-49064') {
          this.logger.info({ truck, routes, firstDelay });
      }*/

      /*const completedLate = this.helper.find(routes, (r) => {
          const actualEndRunningTime = this.helper.get(r, 'actualData.endRunningTime', 0);
          const plannedEndRunningTime = this.helper.get(r, 'endRunningTime', 0);
          const endLogType = this.helper.get(r, 'additionalData.endLogType', 'NORMAL');
           return (
              r.status === 'COMPLETED' &&
              (
                  actualEndRunningTime - plannedEndRunningTime >= lateThreshold ||
                  endLogType === 'RED'
              )
          );
      });*/

      /**
       * if all orders are completed and no error return to normal
       * */
      // if (!firstActive && !lastInTransit && !completedLate) {

      if (!firstActive && !lastInTransit) {
        if (lastCompleted && lastCompleted.additionalData) {
          className = lastCompleted.additionalData.endLogType || 'NORMAL';
          isTerminateEarly = true;
        }
      }

      if (lastInTransit) {
        route = _objectSpread({}, lastInTransit);
        className = lastInTransit && lastInTransit.additionalData ? lastInTransit.additionalData.startLogType : 'NORMAL';

        var durationLast = _moment.default.duration(currentTime.diff(lastInTransit.endTime));

        var secondsLast = durationLast.asSeconds();

        if (secondsLast >= lateThreshold) {
          className = 'RED';
        } else if (secondsLast >= quiteLateThreshold) {
          className = className === 'RED' ? 'RED' : 'YELLOW';
        }
      } else if (firstActive) {
        route = _objectSpread({}, firstActive);

        if (lastCompleted && lastCompleted.additionalData) {
          className = lastCompleted.additionalData.endLogType || 'NORMAL';
        } else {
          className = firstActive && firstActive.additionalData ? firstActive.additionalData.startLogType : 'NORMAL';
        }

        var durationFirst = _moment.default.duration(currentTime.diff(firstActive.estimateTime));

        var secondsFirst = durationFirst.asSeconds();

        if (secondsFirst >= lateThreshold) {
          className = 'RED';
        } else if (secondsFirst >= quiteLateThreshold) {
          className = className === 'RED' ? 'RED' : 'YELLOW';
        }
      }

      return {
        route: route,
        className: className,
        isTerminateEarly: isTerminateEarly
      };
    }
  }, {
    key: "startTimer",
    value: function startTimer(currentInterval) {
      var today = new Date();
      var h = today.getHours();
      var m = today.getMinutes();
      var s = today.getSeconds();
      this.currentSeconds = Number(h * 60 * 60 + m * 60 + s); // this.timerOnInit = true;
      // 1min

      this.timer = setTimeout(this.startTimer, currentInterval ? currentInterval * 1000 : 60000); // 1sec
      // this.timer = setTimeout(this.startTimer, 1000);
    }
  }, {
    key: "calcStartTime",
    value: function calcStartTime(_ref7) {
      var route = _ref7.route,
          routeType = _ref7.routeType,
          showSeconds = _ref7.showSeconds;
      var time = null;
      var endStr = showSeconds ? 19 : 16;

      switch (routeType) {
        case 'plannedRoutes':
          time = (0, _moment.default)(route.startTime).add(route.runningTime, 'seconds').format('YYYY-MM-DD HH:mm:ss');
          return time.substring(11, endStr);

        case 'actualRoutes':
          time = (0, _moment.default)(route.actualData.startTime).add(route.actualData.runningTime, 'seconds').format('YYYY-MM-DD HH:mm:ss');
          return time.substring(11, endStr);
      }
    }
  }, {
    key: "handleSort",
    value: function handleSort(colName) {
      for (var _i = 0, _Object$entries = Object.entries(this.isSortAsc); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (key !== colName) {
          this.isSortAsc[key] = null;
        }
      }

      this.isSortAsc[colName] = this.isSortAsc[colName] === null ? true : !this.isSortAsc[colName];
      this.$emit('sort', {
        isSortAsc: this.isSortAsc[colName],
        colName: colName
      });
    }
  }]);
  return MRGanttChartComponent;
}((0, _vuePropertyDecorator.Mixins)(_milkRunV.MilkRunV2Mixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], MRGanttChartComponent.prototype, "$isFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  default: []
})], MRGanttChartComponent.prototype, "truckStatusFromSocket", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: 'daily'
})], MRGanttChartComponent.prototype, "planViewType", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 10
})], MRGanttChartComponent.prototype, "defaultTimeStepper", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 600
})], MRGanttChartComponent.prototype, "ganttChartHeight", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttChartComponent.prototype, "isVerticallyAutoScrolling", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttChartComponent.prototype, "isDashboard", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttChartComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], MRGanttChartComponent.prototype, "isClickable", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], MRGanttChartComponent.prototype, "isEnableAllTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 0
})], MRGanttChartComponent.prototype, "initAutoAddedDays", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  default: ['plannedRoutes']
})], MRGanttChartComponent.prototype, "routeViewOptions", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: null
})], MRGanttChartComponent.prototype, "currentPlanId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], MRGanttChartComponent.prototype, "isPlay", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MRGanttChartComponent.prototype, "isPause", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  default: []
})], MRGanttChartComponent.prototype, "alertType", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('initAutoAddedDays')], MRGanttChartComponent.prototype, "onInitAutoAddedDaysChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$planDateRange')], MRGanttChartComponent.prototype, "onPlanDateRangeChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$truckLoading')], MRGanttChartComponent.prototype, "onTruckLoadingChanges", null);
MRGanttChartComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MRGanttChartComponent',
  components: {
    'map-world': _mapWorld.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-tooltip': _elementUi.Tooltip,
    'el-dialog': _elementUi.Dialog,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-button': _elementUi.Button
  }
})], MRGanttChartComponent);
var _default = MRGanttChartComponent;
exports.default = _default;